var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./styles.scss";
import * as PrimitiveDialog from "@react-components/primitives/Dialog/Dialog";
import { LazyMotion, domAnimation, m, AnimatePresence } from "framer-motion";
import { RecoilRoot, useRecoilState, useRecoilValue, useSetRecoilState, } from "recoil";
import { viewportSlideOpenAtom } from "@react-components/ui/ViewportSlide/atmos";
import { viewportSlideVariants } from "@react-components/ui/ViewportSlide/animations";
var Root = function (_a) {
    var children = _a.children, onOpenChange = _a.onOpenChange, otherProps = __rest(_a, ["children", "onOpenChange"]);
    var isOpen = useRecoilValue(viewportSlideOpenAtom);
    return (_jsx(LazyMotion, { features: domAnimation, children: _jsxs(PrimitiveDialog.DialogRoot, __assign({}, otherProps, (onOpenChange && {
            onOpenChange: onOpenChange,
        }), { open: isOpen, children: [_jsx(PrimitiveDialog.DialogOverlay, __assign({ className: "overlay" }, otherProps)), children] })) }));
};
var ViewportSlide = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RecoilRoot, { children: _jsx(Root, __assign({}, otherProps, { children: children })) }));
};
var ViewportSlideClose = function (_a) {
    var onClick = _a.onClick, children = _a.children, otherProps = __rest(_a, ["onClick", "children"]);
    var setOpen = useSetRecoilState(viewportSlideOpenAtom);
    return (_jsx(PrimitiveDialog.DialogClose, __assign({}, otherProps, { onClick: function (e) {
            setOpen(false);
            onClick && onClick(e);
        }, children: children })));
};
var ViewportSlideContent = function (_a) {
    var onInteractOutside = _a.onInteractOutside, children = _a.children, otherProps = __rest(_a, ["onInteractOutside", "children"]);
    var _b = __read(useRecoilState(viewportSlideOpenAtom), 2), isOpen = _b[0], setOpen = _b[1];
    return (_jsx(AnimatePresence, { children: isOpen && (_jsx(m.div, { initial: "closed", animate: "open", exit: "closed", transition: { easings: [0, 0.2, 0.4, 1] }, variants: viewportSlideVariants, className: "viewport-slide", children: _jsx(PrimitiveDialog.DialogContent, __assign({ forceMount: true, className: "viewport-slide" }, otherProps, { onInteractOutside: function (e) {
                    setOpen(function (prev) { return !prev; });
                    onInteractOutside && onInteractOutside(e);
                }, children: _jsx("div", { className: "viewport-slide__container", children: _jsx("div", { className: "viewport-slide__content", children: children }) }) })) })) }));
};
var ViewportSlideTrigger = function (_a) {
    var children = _a.children, onClick = _a.onClick, otherProps = __rest(_a, ["children", "onClick"]);
    var setOpen = useSetRecoilState(viewportSlideOpenAtom);
    return (_jsx(PrimitiveDialog.DialogTrigger, __assign({}, otherProps, { onClick: function (e) {
            setOpen(function (prev) { return !prev; });
            onClick && onClick(e);
        }, children: children })));
};
export { ViewportSlide, ViewportSlideContent, ViewportSlideTrigger, ViewportSlideClose, };
